import { memo } from "react";

import classnames from "classnames";
import { isNotPresent } from "neetocist";
import { Typography, Button } from "neetoui";

import CopyToClipboardButton from "components/CopyToClipboardButton";

import SingleValue from "./CountryPicker/SingleValue";
import { getPhoneData } from "./utils";

const PhoneNumber = ({
  className,
  defaultCountry = "IN",
  value,
  showEmoji = false,
  children,
  linkable = false,
  linkPrefix = "tel:",
  showCopyButton = false,
  ...otherProps
}) => {
  if (isNotPresent(value) && isNotPresent(children)) return null;

  const { international, countryCode } = getPhoneData(
    value || children,
    defaultCountry
  );
  const link = linkable ? `${linkPrefix}${value}` : undefined;

  return (
    <div className={classnames(["flex items-center gap-x-2", className])}>
      <SingleValue {...{ countryCode, showEmoji, ...otherProps }} />
      <Typography style="body2" {...otherProps}>
        {linkable ? (
          <Button
            className="neeto-molecules-phone-number truncate"
            data-testid="phone-number-link"
            href={link}
            style="link"
          >
            {international}
          </Button>
        ) : (
          international
        )}
      </Typography>
      {showCopyButton && (
        <CopyToClipboardButton
          className="flex-shrink-0"
          size="small"
          style="text"
          value={international}
        />
      )}
    </div>
  );
};
export default memo(PhoneNumber);
